import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const moduleNum = (id) => parseInt(String(id).replace(/\D/g, ""), 10) || 0;

export const useDistribution = () =>
  useQuery({
    queryKey: ["distribution"],
    queryFn: async () => {
      const { data } = await api.get("/admin/questions/distribution");
      return { ...data, modules: [...(data.modules ?? [])].sort((a, b) => moduleNum(a.id) - moduleNum(b.id)) };
    },
    staleTime: 5 * 60_000,
  });
